/**
  Created: 20/Apr/2018
*/

import * as _ from "lodash";
import { Observable } from 'rxjs';
import { PlaylistContent } from '../models/campaign';

export class PreviewAlgo {

  contents: Array<PlaylistContent>;  // List of contents.
  finalDuration: number = 0;  // In second. Not in millisecond.
  timePassTillNow: number = 0;  // In second.
  nextTime: number = 0;  // In second.
  indexCurrent: number;
  indexNext: number;
  totalContents: number;
  intervalObj: number=0;
  totalValidContents: number;
  contentDurationIndex: string;
  debugLog: Array<any> = [];
  logPush: any = function() { this.debugLog.push(arguments) }

  constructor(
    contents: Array<PlaylistContent>,
    finalDuration: number,
    contentDurationIndex: string,
    intervalObj: any
  ) {
    this.contents = contents;
    this.intervalObj = (intervalObj !== undefined) ? intervalObj.val : 0;
    this.finalDuration = finalDuration;
    this.contentDurationIndex = contentDurationIndex ? contentDurationIndex : 'durationInSeconds';
    this.totalContents = _.get(this.contents, 'length', 0);
    this.totalValidContents = _.get(this.contents, 'length', 0);
    this.logPush('this.finalDuration', this.finalDuration, " | contents > ", this.contents);
  }

  start(): Observable<PlaylistContent> {
    let interval = 1000 /* ms */,
      take = (this.intervalObj) ? ((this.finalDuration +1) - this.intervalObj) : this.finalDuration + 1;
    
    return Observable
      .interval(interval)
      .take(take)
      .map(v => this.differentContentInValidTime(v + this.intervalObj));
  }

  // Return media, if it has right time to play
  private differentContentInValidTime(time: number): any {
    this.timePassTillNow = time;
    // this.logPush('this.timePassTillNow > ', this.timePassTillNow);
    let content: any;
    if (time >= this.nextTime && time < this.finalDuration) {
      content = this.getNextValidContent();
      console.log("Content: ", content);
      if (content) {
        this.nextTime += this.getDurationOfContent(content); // calculate next time
        this.logPush('content > ', content, ', Play content for ', this.getDurationOfContent(content), ' second. nextTime > ', this.nextTime);
      }
    }
    if (time > this.nextTime) {
      return { "content": null, "durationPassInSecond": this.nextTime };
    }
    else {
      return { "content": content, "durationPassInSecond": this.nextTime };
    }
  }

  getNextValidContent(): PlaylistContent {
    let content: PlaylistContent;
    console.log("TotalValidContents: ", this.totalValidContents);
    if (this.totalValidContents > 0) {
      let _conte: PlaylistContent = this.getNextContent();
      if (_conte && this.isValidContent(_conte)) {
        content = _conte;
      }
      else {
        this.logPush("invalid content", _conte);
        this.totalValidContents--;
        this.getNextValidContent();
      }
    }
    return content;
  }

  isValidContent(content: PlaylistContent): boolean {
    // check duration is positive value
    return (!(this.getDurationOfContent(content) > 0)) ? false : true;
  }

  getDurationOfContent(content: PlaylistContent): number {
    return parseInt(content[this.contentDurationIndex]) ? parseInt(content[this.contentDurationIndex]) : 0;
  }

  getNextContent(): PlaylistContent {
    let different_content: PlaylistContent;
    if (this.indexCurrent == null) {
      this.indexCurrent = 0;
      if (this.totalContents > 0) {  // FirstTime: assign first content.
        different_content = this.contents[0];
        this.logPush('First content > ', different_content);
      }
    }
    if (this.indexNext == null) {
      this.indexNext = 0; // (this.totalContents > 1) ? 1 : 0;
    }
    // Set 'different_content' value if current_content and next_content are not same.
    if ((this.indexCurrent != this.indexNext) &&
      !_.isEqual(this.contents[this.indexCurrent], this.contents[this.indexNext])
    ) {
      different_content = this.contents[this.indexNext];
    }

    // set next index.
    if (this.totalContents > 1) {
      this.indexCurrent = _.cloneDeep(this.indexNext);
      this.indexNext++;
      if (this.indexNext == this.totalContents) {
        this.indexNext = 0;
      }
    }
    if (this.indexCurrent == this.indexNext && 
      different_content.contentType == "AUDIO"
    ) {
      this.indexCurrent = null;
    }
    return different_content;
  }
}


// WEBPACK FOOTER //
// ./src/app/pages/cms/components/campaign/services/campaign-preview-algo.ts